import { useIbMembership } from '@frontends/feature-ib';

// Membership = has programs or the impersonation right; the host flag is already folded in via isAvailable.
// Call only under IbDeskGateway
const useIsIbDeskAvailable = (): boolean => {
  const { isIb } = useIbMembership();

  return isIb;
};

export default useIsIbDeskAvailable;
